/*
  Evenement pubsub pour les notifications gérées dans app.component
 */


export enum typeEvents {
  loading = 'loading',
  roleUpdated = 'role-updated',
  roleExisted = 'exist-role',
  pageSaved = 'page-saved',
  imageSaved = 'image-saved',
  docSaved = 'doc-saved',
  likeSaved = 'like-saved',
  commentSaved = 'comm-saved',
  noPageRights = 'page-rights',
}

